module.exports = __webpack_public_path__ + "img/project_geoquiz.d7b38ff3.png";